import {
  CREATE_EMPRESA_REQUEST,
  CREATE_EMPRESA_SUCCESS,
  CREATE_EMPRESA_FAILURE,
  FETCH_EMPRESAS_REQUEST,
  FETCH_EMPRESAS_SUCCESS,
  FETCH_EMPRESAS_FAILURE,
  FETCH_EMPRESA_REQUEST,
  FETCH_EMPRESA_SUCCESS,
  FETCH_EMPRESA_FAILURE,
  UPDATE_EMPRESA_REQUEST,
  UPDATE_EMPRESA_SUCCESS,
  UPDATE_EMPRESA_FAILURE,
  DELETE_EMPRESA_REQUEST,
  DELETE_EMPRESA_SUCCESS,
  DELETE_EMPRESA_FAILURE,
  SET_EMPRESAS_PAGE,
  SET_EMPRESAS_LIMIT
} from '../../../constants/empresas/Empresas';

interface EmpresasState {
  empresas: any[];
  currentEmpresa: any | null;
  loading: boolean;
  success: boolean;
  error: string | null;
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

const INIT_STATE: EmpresasState = {
  empresas: [],
  currentEmpresa: null,
  loading: false,
  success: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0
  }
};

export default (state = INIT_STATE, action: any): EmpresasState => {
  switch (action.type) {
    case CREATE_EMPRESA_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case CREATE_EMPRESA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        currentEmpresa: action.payload.empresa,
        empresas: [...state.empresas, action.payload.empresa],
        pagination: {
          ...state.pagination,
          total: state.pagination.total + 1,
          totalPages: Math.ceil((state.pagination.total + 1) / state.pagination.limit)
        }
      };

    case CREATE_EMPRESA_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    case FETCH_EMPRESAS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_EMPRESAS_SUCCESS:
      return {
        ...state,
        loading: false,
        empresas: action.payload.data,
        pagination: {
          total: action.payload.meta.total,
          page: action.payload.meta.page,
          limit: action.payload.meta.limit,
          totalPages: action.payload.meta.totalPages
        }
      };

    case FETCH_EMPRESAS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_EMPRESA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_EMPRESA_SUCCESS:
      return {
        ...state,
        loading: false,
        currentEmpresa: action.payload.empresa
      };

    case FETCH_EMPRESA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case UPDATE_EMPRESA_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case UPDATE_EMPRESA_SUCCESS:
      const updatedEmpresas = state.empresas.map(empresa =>
        empresa.id === action.payload.empresa.id
          ? action.payload.empresa
          : empresa
      );

      return {
        ...state,
        loading: false,
        success: true,
        currentEmpresa: action.payload.empresa,
        empresas: updatedEmpresas
      };

    case UPDATE_EMPRESA_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    case DELETE_EMPRESA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case DELETE_EMPRESA_SUCCESS:
      const filteredEmpresas = state.empresas.filter(
        empresa => empresa.id !== parseInt(action.payload, 10)
      );

      return {
        ...state,
        loading: false,
        empresas: filteredEmpresas,
        pagination: {
          ...state.pagination,
          total: state.pagination.total - 1,
          totalPages: Math.ceil((state.pagination.total - 1) / state.pagination.limit)
        }
      };

    case DELETE_EMPRESA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case SET_EMPRESAS_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload
        }
      };

    case SET_EMPRESAS_LIMIT:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          limit: action.payload,
          totalPages: Math.ceil(state.pagination.total / action.payload)
        }
      };

    default:
      return state;
  }
};